















































































































































































































































import { calcProgn } from '@/modules/budget-request/components/js/budgetCalcProgn';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Vue, Prop } from 'vue-property-decorator';
import store from '@/services/store';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';
import CAddModal from '@/modules/budget-request/budget-gkkp/c-add-modal.vue';
import CNumberInput from '@/components/c-number-input/index.vue';
import CBudgetAgreementModal, { iAgrBtns } from '@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue';
import CBudgetAgreementLogModal from '@/modules/budget-request/budget-event/budget-event-agreement-log-modal.vue';

@Component({
    name: 'c-bud-event-gu',
    components: {
        'c-add-modal': CAddModal,
        'c-number-input': CNumberInput,
        'c-budg-agr-modal': CBudgetAgreementModal,
        'c-agr-log-modal': CBudgetAgreementLogModal
    }
})
export default class CBudgetEventGu extends Vue {
    @Prop({
        required: true
    })
    private curFilter!: any;

    @Prop({
        required: true,
        default: false
    })
    private editableProp!: boolean;

    @Prop({
        required: false,
        default: 1
    })
    private yearCountProp!: number;

    private yearCount = 1; // период планирования: 1 год или 3 года

    /**
     * при периоде "1 год" колонки curYear+1 и curYear+2 не выводятся в DOM
     */
    private get showAllYears() {
        return this.yearCount !== 1;
    }

    private get editable() {
        // пока снимок не построен, править нечего: любой ранний выход из loadData оставляет его null
        return this.editableProp && this.histDataMap !== null;
    }

    private progress = 0;
    private collapseAll = true;

    private readonly moduleCode = '004.010.001';

    private curYear: number = (new Date()).getFullYear();;
    private curRegion: any | null = null;
    private curDataType: any | null = null;
    private curVariant: any | null = null;
    private curAbp: any | null = null;
    private curGu: any | null = null;
    private curProg: any | null = null;
    private curSubProg: any | null = null;
    private variantEndDate: any | null = null;

    // --параметры для модального добавления
    private nameDict = 'мероприятия';
    private codeDict = 'code';

    private curIndxSpf: number | null = null;

    private dataLst: any[] = [];
    private histDataMap: Map<string, Map<string, any>> | null = null;
    private histCount = 0; // число строк в снимке - по нему определяем удалённые строки
    private isDirty = false; // есть несохранённые изменения (пересчитывается по событию, а не на каждое нажатие клавиши)

    private projectBase: any[] = [];
    private totalSum: any = { declared_sum0: 0, declared_sum1: 0, declared_sum2: 0, value0: 0, value1: 0, value2: 0, abp_value0: 0, abp_value1: 0, abp_value2: 0 };

    private checkedAll = false;

    private readonly modeCode = 'br_project';
    private operationCode: string[] = []; // операции согласования
    private agrBtnLst: iAgrBtns = { back: [], forward: [] };
    private selectArr: any = [];

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    // ------------------------ занятость: защита от повторного нажатия кнопок
    // флаг на каждый процесс, а не один общий счётчик: процессы вложены друг в друга
    // (согласование -> сохранение -> перезагрузка), и снятие флага должно быть идемпотентным
    private loadingFl = false; // идёт загрузка данных
    private savingFl = false; // идёт сохранение
    private agreeingFl = false; // идёт согласование, включая время, пока открыта модалка
    // статус, который видел пользователь при открытии модалки согласования - отправляем на сервер
    // для проверки, что за время открытой модалки статус в БД не изменился (чужое согласование)
    private agrCurrentStatus: number | null = null;

    private loadSeq = 0; // поколение загрузки: loadData могут вызвать повторно, пока предыдущая ещё в полёте

    private get busy(): boolean {
        return this.loadingFl || this.savingFl || this.agreeingFl;
    }
    // ------------------------

    private mounted() {
        this.$emit('chgBusy', false);
        this.$watch('busy', (busy: boolean) => { this.$emit('chgBusy', busy); });
        this.$emit('chgEditable', this.editable);
        this.$watch('editable', (editable: boolean) => { this.$emit('chgEditable', editable); });
        this.curYear = this.curFilter.curYear;
        this.curRegion = this.curFilter.curRegion;
        this.curDataType = this.curFilter.curDataType;
        this.curVariant = this.curFilter.curVariant;
        this.curAbp = this.curFilter.curAbp;
        this.curGu = this.curFilter.curGu;
        this.curProg = this.curFilter.curProg;
        this.curSubProg = this.curFilter.curSubProg;
        this.variantEndDate = this.curFilter.variantEndDate;
        this.yearCount = this.yearCountProp;
        this.loadProjectLst();
        this.loadData();
        this.$watch('usrId', () => {
            if (!this.usrId) { return; }
            this.loadOperations();
        })
    }

    /**
     * период планирования (1 год / 3 года) - переключается без перезагрузки данных
     */
    private chgYearCount(value: number) {
        this.yearCount = value;
    }

    private chgEvent(params: any) {
        this.curYear = params.curYear;
        this.curRegion = params.curRegion;
        this.curDataType = params.curDataType;
        this.curVariant = params.curVariant;
        this.curAbp = params.curAbp;
        this.curGu = params.curGu;
        this.curProg = params.curProg;
        this.curSubProg = params.curSubProg;
        this.variantEndDate = params.variantEndDate;
        this.loadProjectLst();
        this.loadData();
    }

    /**
     * сворачивать специфики
    */
    private clkCollapse(indx: number | null) {

        if (indx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.dataLst) {
                this.$set(el, 'collapse', this.collapseAll);
            }
        } else {
            const collapse = !this.dataLst[indx].collapse;
            this.$set(this.dataLst[indx], 'collapse', collapse);
            if (this.collapseAll && !collapse) {
                for (const el of this.dataLst) {
                    if (el.collapse) { return; }
                }
                this.collapseAll = false;
            } else if (!this.collapseAll && collapse) {
                for (const el of this.dataLst) {
                    if (!el.collapse) { return; }
                }
                this.collapseAll = true;
            }
        }
    }

    private addProject (indx: number) {
        this.curIndxSpf = indx;
        const dictLst = [];
        const data = this.dataLst[indx];
        for (const el of this.projectBase) {
            let fl = false;
            for (let i = 0; i < data.items.length; i++) {
                if (data.items[i].project.code === el.code) {
                    fl = true;
                    break;
                }
            }
            if (!fl) { dictLst.push(el); }
        }

        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.openModal(dictLst);
    }

    private addModalClk(items: any[]) {
        if (this.curIndxSpf === null) { return; }
        const projectLst = this.dataLst[this.curIndxSpf].items;
        const vl0 = this.dataLst[this.curIndxSpf].declared_sum0 === undefined || this.dataLst[this.curIndxSpf].declared_sum0 === null ? undefined : 0;
        const vl1 = this.dataLst[this.curIndxSpf].declared_sum1 === undefined || this.dataLst[this.curIndxSpf].declared_sum1 === null ? undefined : 0;
        const vl2 = this.dataLst[this.curIndxSpf].declared_sum2 === undefined || this.dataLst[this.curIndxSpf].declared_sum2 === null ? undefined : 0;
        for (const el of items) {
            const obj = { project: el, value0: vl0, value1: vl1, value2: vl2, editable: true };
            projectLst.push(obj);
        }
        projectLst.sort((a: any, b: any) => (a.project.code > b.project.code) ? 1 : -1);
        this.dataLst[this.curIndxSpf].items = projectLst;
        this.updDirty();
    }

    private async loadData() {
        const seq = ++this.loadSeq;
        this.loadingFl = true;
        try {
            await this.loadDataInner();
        } catch (error) {
            this.progress = 100;
            makeToast(this, 'danger', this.tblTitle.load_data, (error as Error).toString());
        } finally {
            // если поверх этой загрузки уже начали новую - флаг снимет она
            if (seq === this.loadSeq) { this.loadingFl = false; }
        }
    }

    private async loadDataInner() {
        this.dataLst = [];
        this.checkedAll = false;
        this.histDataMap = null;
        this.isDirty = false; // синхронно: пока снимка нет, несохранённых изменений быть не может
        this.totalSum = { declared_sum0: 0, declared_sum1: 0, declared_sum2: 0, value0: 0, value1: 0, value2: 0, abp_value0: 0, abp_value1: 0, abp_value2: 0 };
        if (!this.curAbp || !this.curDataType || !this.curRegion || !this.curVariant || !this.curGu || !this.curProg || !this.curProg.prg || (this.curSubProg && !this.curSubProg.ppr)) {
            return
        }
        this.progress = 30;
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, gu: this.curGu.code, date_b: this.curVariant.date_start, date_e: this.variantEndDate, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: null, locale: this.$i18n.locale, vers_year: versYear };

        const loadResult = await Promise.all([
            this.loadTotal(params),
            this.loadProjectData(params),
            this.loadAgreement()
        ]);

        const totalResult: any[] | null = loadResult[0];
        const projectData: any[] | null = loadResult[1];
        const agrMap: Map<any, any> = loadResult[2];
        this.progress = 70;
        if (totalResult === null || projectData === null) {
            this.progress = 100;
            makeToast(this, 'warning', this.tblTitle.load_data, this.tblTitle.data_not_loaded);
            return;
        }
        const result: any[] = [];
        for (const elTotal of totalResult) {
            const obj = { spf: elTotal.spf, collapse: this.collapseAll, declared_sum0: elTotal.declared_sum0, declared_sum1: elTotal.declared_sum1, declared_sum2: elTotal.declared_sum2, items: [], totalSum: {value0: 0, value1: 0, value2: 0, abp_value0: 0, abp_value1: 0, abp_value2: 0} }
            this.totalSum.declared_sum0 += elTotal.declared_sum0 ? elTotal.declared_sum0 : 0;
            this.totalSum.declared_sum1 += elTotal.declared_sum1 ? elTotal.declared_sum1 : 0;
            this.totalSum.declared_sum2 += elTotal.declared_sum2 ? elTotal.declared_sum2 : 0;
            this.setProjects(obj, projectData, agrMap);
            result.push(obj);
        }
        this.progress = 90;
        // -- добавить оставшиеся, если в тотале нет этой специфики, но в нашей таблице есть
        while (projectData.length) {
            const obj = { spf: projectData[0].spf, collapse: this.collapseAll, items: [], totalSum: {value0: 0, value1: 0, value2: 0, abp_value0: 0, abp_value1: 0, abp_value2: 0} }
            this.setProjects(obj, projectData, agrMap);
            result.push(obj);
        }
        // --
        result.sort((a: any, b: any) => (a.spf.spf > b.spf.spf) ? 1 : -1);
        this.dataLst = result;
        this.progress = 100;
        this.setHistDataMap(result);
    }

    private setProjects(obj: any, projectData: any[], agrMap: Map<any, any>) {
        let findFL = false;
        let agrFl = false;
        for (let i = 0; i < projectData.length; i++) {
            const projectEl = projectData[i];
            if (projectEl.spf.spf === obj.spf.spf) {
                findFL = true;
                const item = JSON.parse(JSON.stringify(projectEl));
                // --- agreement
                const spfMap = agrMap.get(projectEl.spf.spf);
                if (spfMap) {
                    const projAgr = spfMap.get(item.project.code);
                    if (projAgr) {
                        item.status = setNameLang(this.$i18n.locale, projAgr.status);
                        item.agr_id = projAgr.id;
                        item.editable = this.editableStep (projAgr);
                        item.agrObj = projAgr;
                        if (projAgr.availableStep) {
                            item.checked = this.checkedAll;
                            agrFl = true;
                        }
                    }

                }
                // ----
                for (let j = 0; j < 3; j++) {
                    if (item[`value${j}`] === null) {
                        item[`value${j}`] = obj[`declared_sum${j}`] != undefined && obj[`declared_sum${j}`] != null ? 0 : undefined;
                    } else {
                        obj.totalSum[`value${j}`] += item[`value${j}`];
                        this.totalSum[`value${j}`] += item[`value${j}`];
                    }
                    if (item[`abp_value${j}`]) {
                        obj.totalSum[`abp_value${j}`] += item[`abp_value${j}`];
                        this.totalSum[`abp_value${j}`] += item[`abp_value${j}`];
                    }
                }
                delete item.spf;
                obj.items.push(item);
                projectData.splice(i, 1);
                i--;
            } else if (findFL) {
                if (agrFl) {
                    obj.checked = this.checkedAll;
                }
                obj.items.sort((a: any, b: any) => (a.project.code > b.project.code) ? 1 : -1);
                return;
            }
        }
        if (agrFl) {
            obj.checked = this.checkedAll;
        }
        obj.items.sort((a: any, b: any) => (a.project.code > b.project.code) ? 1 : -1);
    }

    private editableStep(projAgr: any) {
        if (projAgr && projAgr.operation_codes) {
            for (const el of projAgr.operation_codes) {
                if (el  === 'events_gu_edit') {
                    return true;
                }
            }
        }
        return false;
    }

    private setHistDataMap(dataLst: any[]) {
        const newDataLst = JSON.parse(JSON.stringify(dataLst));
        const resultMap = new Map();
        for (const el of newDataLst) {
            const projMap = new Map();
            for (const item of el.items) {
                projMap.set(item.project.code, item);
            }
            // if (projMap.size) { resultMap.set(el.spf.spf, projMap); }
            resultMap.set(el.spf.spf, projMap);
        }
        this.histDataMap = resultMap;
        this.histCount = newDataLst.reduce((sum: number, el: any) => sum + el.items.length, 0);
        this.updDirty();
    }

    private async loadProjectData(params: any) {
        let result: any = null;
        try {
            const response = await fetch(`/api-py/get-budget-events-gu-abp/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
                return result;
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-events-gu-abp', `${response.status} - ${response.statusText}`);
                return null;
                }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-events-gu-abp', (error as Error).toString());
            return null;
        }
    }

    private async loadTotal(params: any) {
        let result: any = null;
        try {
            const response = await fetch(`/api-py/get-req-total-for-event-gu/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
                if (result.prev_variant == null) {
                    makeToast(this, 'warning', this.tblTitle.load_data, this.tblTitle.no_prev_variant);
                    return null;
                }
                return result.result;
            } else {
                makeToast(this, 'danger', 'Ошибка get-req-total-for-event-gu', `${response.status} - ${response.statusText}`);
                return null;
                }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-req-total-for-event-gu', (error as Error).toString());
            return null;
        }
    }

    private async loadProjectLst() {
        this.projectBase = [];
        let result: any = null;
        if (!this.curAbp || !this.curDataType || !this.curRegion || !this.curVariant || !this.curGu || !this.curProg || !this.curProg.prg || (this.curSubProg && !this.curSubProg.ppr)) {
            return
        }
        const params = { curYear: this.curYear, abp: this.curAbp.abp, region: this.curRegion.code, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: null };
        try {
            const response = await fetch(`/api-py/get-projectlst-for-budget-event/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
                this.projectBase = result;
            } else {
                makeToast(this, 'danger', 'Ошибка get-projectlst-for-budget-event', `${response.status} - ${response.statusText}`);
                }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-projectlst-for-budget-event', (error as Error).toString());
        }
    }

    /**
     * ввод цифр
     */
     private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }


    /**
     * изменение значения
     * @param obj объект
     * @param fieldNumber номер поля 0-3
     * @param indxSpf индекс dataLst
     */
     private chgValue(obj: any, fieldNumber: string, indxSpf: number) {
        const fieldName = `value${fieldNumber}`
        if (isNaN(obj[fieldName]) || obj[fieldName]==='') { this.$set(obj, fieldName, 0); }
        obj[fieldName] = (Math.round(parseFloat(obj[fieldName]) * 10))/10;
        this.dataLst[indxSpf].totalSum[fieldName] = 0;
        for (const el of this.dataLst[indxSpf].items) {
            const value =  el[fieldName] ? el[fieldName] : 0;
            this.dataLst[indxSpf].totalSum[fieldName] += value;
        }
        let value0 = 0;
        let value1 = 0;
        let value2 = 0;
        for (const el of this.dataLst) {
            value0 += el.totalSum.value0 ? el.totalSum.value0: 0;
            value1 += el.totalSum.value1 ? el.totalSum.value1: 0;
            value2 += el.totalSum.value2 ? el.totalSum.value2: 0;
        }
        this.totalSum.value0 = value0;
        this.totalSum.value1 = value1;
        this.totalSum.value2 = value2;
        this.updDirty();
    }

    private getSaveArr() {
        const saveArr: any[] = [];
        if (!this.histDataMap) { return saveArr; }
        const histMap = this.cloneMap(this.histDataMap);
        for (const spfEl of this.dataLst) {
            for (const el of spfEl.items) {
                const changed = this.checkChanged(histMap, spfEl.spf.spf, el);
                if (changed) {
                    const value0 = el.value0 ? el.value0 : null;
                    const value1 = el.value1 ? el.value1 : null;
                    const value2 = el.value2 ? el.value2 : null;
                    const id = el.id ? el.id : null;
                    const saveObj = { id: id, spf: spfEl.spf.spf, project: el.project.code, value0: value0, value1: value1, value2: value2 }
                    saveArr.push(saveObj);
                }
            }
        }
        for (const [keySpf, projMap] of histMap) {
            for (const [keyProj, projObj] of projMap) {
                const id = projObj.id ? projObj.id : null;
                const saveObj = { id: id, spf: keySpf, project: keyProj, value0: null, value1: null, value2: null }
                saveArr.push(saveObj);
            }
        }
        return saveArr;
    }

    private async saveClk(flLoad = true): Promise<boolean> {
        if (this.savingFl) { return false; } // сохранение уже идёт
        this.savingFl = true;
        try {
            return await this.saveClkInner(flLoad);
        } catch (error) {
            makeToast(this, 'danger', this.tblTitle.saving, (error as Error).toString());
            return false;
        } finally {
            this.savingFl = false;
        }
    }

    private async saveClkInner(flLoad: boolean): Promise<boolean> {
        if (!this.editable) { return false; }
        const saveArr: any[] = this.getSaveArr();
        if (!saveArr.length) {
            makeToast(this, 'warning', this.tblTitle.saving, this.tblTitle.no_changes_to_save);
            return false;
        }

        const saveObj = { items: saveArr, curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, gu: this.curGu.code, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: null, userId: this.usrId, locale: this.$i18n.locale }

        try {
            const url = '/api-py/save-budget-events-gu-abp';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            response = await response.json();
            let success = true;
            for (const r of response) {
                if (r.result !== 'success') {
                    success = false;
                    if (r.result == 'warning') {
                        makeToast(this, 'warning', 'Сообщение', r.errTxt);
                    } else {
                        makeToast(this, 'danger', 'Сообщение', `${this.tblTitle.saving} ${r.result}`);
                    }
                }
            }
            if (success) {
                makeToast(this, 'success', this.tblTitle.saving, this.tblTitle.data_saved);
                if (flLoad) { this.loadData(); }
            }
            return success;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка сохранения', (error as Error).toString());
            return false;
        }
    }

    private cloneMap(originalMap: any) {
        const outerClone = new Map();
        if (!originalMap) { return outerClone; } // страховка второго уровня: for...of по null падает
        for (const [outerKey, innerMap] of originalMap) {
            const innerClone = new Map();
            for (const [innerKey, value] of innerMap) {
            innerClone.set(innerKey, { ...value });
            }
            outerClone.set(outerKey, innerClone);
        }
        return outerClone;
    }

    private checkChanged(histMap: Map<any, any>, spf: number, item: any) {
        const spfMap = histMap.get(spf);
        if (!spfMap) { return true; }
        const projObj = spfMap.get(item.project.code);
        if (!projObj) { return true; }
        const fl = this.isValuesChanged(projObj, item);
        spfMap.delete(item.project.code);
        if (!spfMap.size) { histMap.delete(spf); }
        return fl;
    }

    /**
     * отличаются ли суммы строки от снимка (все 3 года, независимо от режима "1 год")
     * @param histObj строка из снимка
     * @param item текущая строка
     */
    private isValuesChanged(histObj: any, item: any): boolean {
        const value0 = item.value0 ? item.value0 : null;
        const value1 = item.value1 ? item.value1 : null;
        const value2 = item.value2 ? item.value2 : null;
        const histVal0 = histObj.value0 ? histObj.value0 : null;
        const histVal1 = histObj.value1 ? histObj.value1 : null;
        const histVal2 = histObj.value2 ? histObj.value2 : null;
        return histVal0 !== value0 || histVal1 !== value1 || histVal2 !== value2;
    }

    /**
     * есть ли несохранённые изменения: правки сумм, новые и удалённые строки.
     * Снимок не клонируется, выход на первом отличии
     */
    private hasChanges(): boolean {
        if (!this.histDataMap) { return false; }
        let matched = 0;
        for (const spfEl of this.dataLst) {
            const spfMap = this.histDataMap.get(spfEl.spf.spf);
            for (const el of spfEl.items) {
                const histObj = spfMap ? spfMap.get(el.project.code) : undefined;
                // новой строки нет в снимке, а у существующей поменялись суммы
                if (!histObj || this.isValuesChanged(histObj, el)) { return true; }
                matched++;
            }
        }
        return matched !== this.histCount; // строку удалили
    }

    private updDirty() {
        this.isDirty = this.hasChanges();
    }

    /**
     * для родителя: снять фокус с поля ввода (сработает change -> chgValue -> updDirty синхронно)
     * и вернуть, есть ли несохранённые изменения. Родитель спрашивает напрямую перед каждым переходом
     */
    public flushAndCheck(): boolean {
        const el = document.activeElement as HTMLElement | null;
        if (el && this.$el.contains(el)) { el.blur(); }
        this.updDirty();
        return this.isDirty;
    }

    /**
     * сохранение перед уходом со вкладки или сменой фильтра: без перезагрузки,
     * таблицу дальше перезагружает каскад фильтра либо уничтожение вкладки
     */
    public async saveBeforeLeave(): Promise<boolean> {
        const flSaved = await this.saveClk(false);
        if (!flSaved) { return false; }
        // данные сохранены без перезагрузки - обновляем снимок, иначе те же изменения снова считаются несохранёнными
        this.setHistDataMap(this.dataLst);
        return true;
    }

    /**
     * отказ от несохранённых правок: таблица пустая до прихода новых данных,
     * иначе при обрыве каскада фильтра старые правки остались бы на экране без баннера
     */
    public discardChanges() {
        this.dataLst = [];
        this.histDataMap = null;
        this.histCount = 0;
        this.isDirty = false;
        this.totalSum = { declared_sum0: 0, declared_sum1: 0, declared_sum2: 0, value0: 0, value1: 0, value2: 0, abp_value0: 0, abp_value1: 0, abp_value2: 0 };
    }

    private deleteProj(spfIndx: number, projIndx: number) {
        const obj = this.dataLst[spfIndx].items[projIndx];
        for (let i = 0; i < 3; i++) {
            if (obj[`value${i}`]) {
                this.dataLst[spfIndx].totalSum[`value${i}`] -= obj[`value${i}`];
                this.totalSum[`value${i}`] -= obj[`value${i}`];
            }
        }

        if (obj.abp_value0 || obj.abp_value1 || obj.abp_value2) {
            for (let i = 0; i < 3; i++) {
                if (obj[`value${i}`]) {obj[`value${i}`] = 0};
            }
        } else {
            this.dataLst[spfIndx].items.splice(projIndx, 1);
        }
        this.updDirty();
    }
    // ------------------------ согласование
    private clkCheck(spfIndx: number | null, projIndx: number | null) {
        if (spfIndx === null) {
            for (const el of this.dataLst) {
                if (el.checked !== undefined && el.checked !== null) {
                    el.checked = this.checkedAll;
                }

                for (const item of el.items) {
                    if (item.checked !== undefined && item.checked !== null) {
                        item.checked = this.checkedAll;
                    }
                }
            }
            return;
        }

        const spfEl = this.dataLst[spfIndx];
        if (projIndx === null) {
            for (const item of spfEl.items) {
                if (item.checked !== undefined && item.checked !== null) {
                    item.checked = spfEl.checked;
                }
            }
        } else {
            spfEl.checked = spfEl.items
                .filter((x: any) => x.checked !== undefined && x.checked !== null)
                .every((x: any) => x.checked);
        }

        this.checkedAll = this.dataLst
            .filter((x: any) => x.checked !== undefined && x.checked !== null)
            .every((x: any) => x.checked);
    }

    private async loadOperations() {
        this.operationCode = [];
        if (this.usrId === null) {
            this.$emit('chgAgrAccess', false);
            return;
        }
        let result = null;
        try {
            result = await fetch(encodeURI(`/api/um/module/link?user=${this.usrId}&modulecode=${this.moduleCode}`));
            if (result.status === 200) {
                result = await result.json();
            }  else {
                if (result.status !== 404) { makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', `${result.status}  ${result.statusText}`); }
                return;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', (error as Error).toString());
            return;
        }
        if (result.operations) {
            for (const el of result.operations) {
                this.operationCode.push(el);
            }
        }
        this.$emit('chgAgrAccess', this.operationCode.length > 0);
    }

    private async loadAgreement() {
        if (!this.operationCode.length) { await this.loadOperations(); }

        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, gu: this.curGu.code,  guLst: [this.curGu.code], prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: null, mode_code: this.modeCode, operation_code: this.operationCode };
        let result = null;
        try {
            const response: any = await fetch(`/api-py/get-budget-event-agreement-gu-lvl/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-gu',  `${response.status} - ${response.statusText}`);
                return new Map();
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-gu', (error as Error).toString());
            return new Map();
        }
        return this.getAgrMap(result);
    }

    private getAgrMap(agrLst: any[]) {
        const resMap = new Map();

        for (const el of agrLst) {
            if (!resMap.has(el.spf)) {
                resMap.set(el.spf, new Map());
            }
            resMap.get(el.spf).set(el.project_code, el);
        }
        return resMap;
    }

    //
    private async checkAgrEventSaved() {
        const saveArr: any[] = this.getSaveArr();
        if (!saveArr.length) {
            return true;
        }
        let fl = false
        await this.$bvModal.msgBoxConfirm(this.tblTitle.check_agr_event_saved.text, {
            title: 'Предупреждение',
            okVariant: 'success',
            okTitle: this.tblTitle.check_agr_event_saved.yes,
            cancelTitle: this.tblTitle.check_agr_event_saved.cancel,
            centered: true,
            size: 'lg',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            noCloseOnBackdrop: true
        })
        .then(value => {
            fl = value;
        })
        .catch(err => {
            console.error(err);
        });
        if (!fl) { return false; }
        const flSaved = await this.saveClk(false);
        if (!flSaved) { return false; }
        // данные сохранены без перезагрузки - обновляем снимок, иначе те же изменения снова считаются несохранёнными
        this.setHistDataMap(this.dataLst);
        return true;
    }

    private async agreementEvent() {
        if (this.busy) { return; }
        this.agreeingFl = true;
        let modalOpened = false;
        try {
            modalOpened = (await this.agreementEventInner()) === true;
        } catch (error) {
            makeToast(this, 'danger', 'Согласование', (error as Error).toString());
        } finally {
            // если модалка открыта - флаг снимет agrClk или её закрытие (@closed)
            if (!modalOpened) { this.agreeingFl = false; }
        }
    }

    private async agreementEventInner() {
        const selectArr: any = [];
        this.selectArr = [];
        this.agrBtnLst = { back: [], forward: [] };
        let firstStatus: number | null = null;
        const notSameStatus = this.getBudgetText('other.notSameStatus'); // Выберите подпрограммы с одинаковым статусом
        const title = this.getBudgetText('other.no_program[0]'); // Согласование
        for (const elSpf of this.dataLst) {
            for (const elProj of elSpf.items) {
                if (elProj.checked) {
                    if (firstStatus === null) { firstStatus = elProj.status.code; }
                    if (firstStatus !== elProj.status.code) {
                            makeToast(this, 'danger', title, `${notSameStatus}!`);
                            return;
                    }
                    selectArr.push({ id: elProj.agr_id });
                }
            }
        }
        if (selectArr.length === 0) {
            const nonSelected = this.getBudgetText('other.no_program[1]'); // Не выбрано ни одной программы/подпрограммы
            makeToast(this, 'warning', title, nonSelected);
            return;
        }
        const flCheckSaved = await this.checkAgrEventSaved();
        if (!flCheckSaved) { return; }

        this.selectArr = selectArr;
        // ---------------
        this.agrCurrentStatus = firstStatus;
        const params = { modeCode: this.modeCode, operationCode: this.operationCode, agrCode: firstStatus };

        let result: any = null;
        try {
            const response: any = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
            result = await response.json();
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-agreement-step-next-back', (error as Error).toString());
            this.progress = 0;
            return;
        }
        if (result.length === 0) {
            makeToast(this, 'warning', 'Согласование', 'Нет доступных шагов согласования!');
            return;
        }
        for (const el of result) {
            let name = el[`name_${this.$i18n.locale}`];
            if (!name) { name = el.name_ru; }
            el.name = name;
            if (el.stepType === 1) {
                this.agrBtnLst.back.push(el);
            } else {
                this.agrBtnLst.forward.push(el);
            }
        }
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAgrModal.showEvent();
        return true;
    }

    /**
     * закрытие модалки согласования без действия - снимаем флаг занятости
     */
    private agrModalClosed() {
        this.agreeingFl = false;
    }

    private async agrClk(data: any) {
        try {
            await this.agrClkInner(data);
        } catch (error) {
            makeToast(this, 'danger', 'Сохранение status', (error as Error).toString());
        } finally {
            this.agreeingFl = false; // согласование завершено, модалка уже закрыта самой clkBtn
        }
    }

    private async agrClkInner(data: any) {
        data.userId = store.state.user.sub;
        data.locale = this.$i18n.locale;
        data.currentStatus = this.agrCurrentStatus; // статус, который видел пользователь - для проверки на сервере
        const saveObj = Object.assign({
            userId: this.usrId,
            items: this.selectArr,
        }, data);
        let result: any = await fetch('/api-py/set_b_event_agreement_step_gu',
            {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
        if (result.status === 200) {
            result = await result.json();
            for (const res of result) {
                if (res.result === 'error') {
                    makeToast(this, 'danger', 'Сохранение status', `${res.errTxt}`);
                    console.error('Ошибка set_b_event_agreement_step_gu', res);
                    return;
                }
            }
            this.loadData();
        } else {
            makeToast(this, 'danger', 'Сохранение status', `Ошибка ${result.status} ${result.statusText}`);
            return;
        }
    }

    private agrLogClk(spfIndx: number, projIndx: number) {
        const id = this.dataLst[spfIndx].items[projIndx].agr_id;
        const agr = this.dataLst[spfIndx].items[projIndx].agrObj;
        let agrObj: any = null;
        if (agr) {
            agrObj = {
                userId: agr.user_id,
                status: agr.status.code,
                name_ru: agr.status ? agr.status.name_ru: '',
                name_kk: agr.status ? agr.status.name_kk: '',
                name_en: agr.status ? agr.status.name_en: '',
                updateDate: agr.update_date,
                commentTxt: agr.comment_txt
            }
        }
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAgrLogModal.showEvent(id, agrObj);
    }
    // ------------------------


    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get tblTitle() {
        const obj = {
            saving: this.getBudgetText('sum_calc_edit.saving'), // Сохранение
            data_saved: this.getBudgetText('sum_calc_edit.data_saved'), // Данные сохранены
            load_data: this.getBudgetText('sum_calc_edit.load_data'), // Загрузка данных
            no_prev_variant: this.getBudgetText('budget-event.no-prev-variant'), // Не найден предыдущий вариант бюджета...
            data_not_loaded: this.getBudgetText('budget-event.data-not-loaded'), // Данные не загружены, редактирование недоступно
            no_changes_to_save: this.getBudgetText('budget-event.no-changes-to-save'), // Нет изменений для сохранения
            status: this.getBudgetText('sum_calc_abp.status'), // Статус
            change_log: this.getBudgetText('sum_calc_abp.change_log'), // Журнал изменений
            unsaved_banner: this.getBudgetText('budget-event.unsaved-changes.banner'), // Внимание: Есть несохраненные изменения!
            check_agr_event_saved: {
                text: this.getBudgetText('budget-event.check-agr-event-saved.text'), // Есть несохраненные изменения. Сохранить перед отправкой?
                yes: this.getBudgetText('budget-event.check-agr-event-saved.yes'), // Сохранить и продолжить
                cancel: this.getBudgetText('budget-event.check-agr-event-saved.cancel'), // Отменить
            }
        }
        return obj
    }

}
